export const FETCH_PROBLEMS = 'FETCH_PROBLEMS';
export const CREATE_PROBLEM = 'CREATE_PROBLEM';
export const UPDATE_PROBLEM = 'UPDATE_PROBLEM';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
